import create, { UseStore } from 'zustand';
import { devtools } from 'zustand/middleware';
import { CQQuizClient } from '../../clients';
import { immer } from '../middleware';
import { APP_CONFIG, NetworkStatus, ScreenShareState } from '../../config';
import { AIProctor } from '../../libs/object-dection/object-detection';
import SpeedTest from '../../libs/utils/speed-test';

enum AppAction {
	SetAppLoading = 'set-app-loading',
}

const initialState: AppState = {
	isOnLine: true,
	isSocketConnected: true,
	disconnectionTimeOut: null,
	loading: false,
	loadingText: '',
	openInApp: false,
	appModalShown: false,
	multipleConnectionWarning: null,
	screenShareState: ScreenShareState.Disabled,
	room: null,
	aiProctoring: null,
	videoElement: null,
	networkSpeed: null,
	speedTest: null,
	networkStatus: NetworkStatus.Online,

	setVideoElement: () => { },
	setAppModalShown: () => { },
	setAppLoading: async () => { },
	handleOpenInApp: async () => { },
	downloadApp: async () => { },
	openLinkInApp: () => { },
	setRoom: () => { },
	setScreenShareState: () => { },
	setAiProctoring: (aiProctoring: AIProctor) => { },
	setNetworkStatus: () => { },
};

export function createAppStore(
	cqQuizClient: CQQuizClient, speedTest: SpeedTest,
): UseStore<AppState> {
	return create<AppState>(immer(devtools((set, get) => {
		const currentNetworkStats = speedTest.getCurrentNetworkStats();
		if (currentNetworkStats) {
			set({
				speedTest,
				networkSpeed: currentNetworkStats,
			});
		}

		speedTest.on('result', (result) => {
			console.log('Speed Test Update: ', result);
			set({
				networkSpeed: result,
			});
		});

		cqQuizClient.on('socket-disconnected', () => {
			set((state) => {
				// eslint-disable-next-line no-param-reassign
				state.isSocketConnected = false;
				// eslint-disable-next-line no-param-reassign
				state.screenShareState = setTimeout(() => {
					// eslint-disable-next-line no-param-reassign
					set((stateInner) => {
						// eslint-disable-next-line no-param-reassign
						stateInner.isOnLine = false;
					});
				}, 4000);
			});
		});
		cqQuizClient.on('socket-connected', () => {
			set((state) => {
				if (get().screenShareState) {
					clearInterval(get().screenShareState);
				}
				// eslint-disable-next-line no-param-reassign
				state.isSocketConnected = true;
				// eslint-disable-next-line no-param-reassign
				state.isOnLine = true;
			});
		});
		cqQuizClient.on('multiple-connection-detected', (status: string) => {
			set({ multipleConnectionWarning: status });
		});
		return {
			...initialState,

			setAppLoading: async (isLoading: boolean, loadingText?: string): Promise<void> => {
				set({
					loading: isLoading,
					loadingText: loadingText || '',
				}, false, AppAction.SetAppLoading);

				return new Promise((resolve) => setTimeout(resolve, 0));
			},

			downloadApp: async (platform?: string): Promise<void> => {
				await cqQuizClient.downloadApp(platform);
			},

			openLinkInApp: (url) => {
				const iframe = document.getElementById('openAppIfram');
				(iframe as HTMLIFrameElement).src = `${APP_CONFIG.ElectronScheme}://${url}`;
			},
			setAppModalShown: (value: boolean) => {
				set({
					appModalShown: value,
				});
			},
			setRoom: (room) => {
				set({
					room,
				});
			},
			setScreenShareState: (value: ScreenShareState) => {
				set({
					screenShareState: value,
				});
			},

			handleOpenInApp: async (state: boolean, link?: string) => {
				if (state) {
					set({
						openInApp: true,
					});
					get().openLinkInApp(link ?? window.location.href);
				} else {
					set({
						openInApp: false,
					});
				}
			},

			setVideoElement(videoElement) {
				set({
					videoElement,
				});
			},

			setNetworkStatus(data: NetworkStatus) {
				switch (data) {
					case NetworkStatus.Offline: {
						get().speedTest?.networkStateChanged(NetworkStatus.Offline);
						set({
							networkStatus: NetworkStatus.Offline,
						});
						break;
					}
					case NetworkStatus.Online: {
						get().speedTest?.networkStateChanged(NetworkStatus.Online);
						set({
							networkStatus: NetworkStatus.Online,
						});
						break;
					}
					case NetworkStatus.Pending: {
						set({
							networkStatus: NetworkStatus.Pending,
						});
						break;
					}
					default: {
						console.log(`Wrong config provided ${data}`);
					}
				}
			},
		};
	}, 'AppStore')));
}
